export const formatPercentage = value => {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatTwoDecimals = value => {
  if (value === null || value === undefined) {
    return '';
  }
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatAsInt = value => {
  if (value === null || value === undefined) {
    return '';
  }
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
};
